import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../styles/theme";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const FooterContainer = styled.footer`
  background: linear-gradient(
    135deg,
    ${theme.colors.dark},
    ${theme.colors.primary}
  );
  color: ${theme.colors.white};
  padding: 5rem 0 2rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
    color: ${theme.colors.accent};
    position: relative;
    padding-bottom: 0.5rem;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 3px;
      background: ${theme.colors.accent};
    }
  }

  p {
    line-height: 1.8;
    color: ${theme.colors.light};
  }

  ul {
    li {
      margin-bottom: 0.8rem;
      display: flex;
      align-items: center;

      a {
        color: ${theme.colors.light};
        transition: all 0.3s ease;

        &:hover {
          color: ${theme.colors.accent};
          padding-left: 5px;
        }
      }

      svg {
        margin-right: 0.5rem;
        font-size: 1.2rem;
        color: ${theme.colors.accent};
      }
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    color: ${theme.colors.white};
    transition: all 0.3s ease;

    &:hover {
      background-color: ${theme.colors.accent};
      transform: translateY(-5px);
    }

    svg {
      font-size: 1.2rem;
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: ${theme.colors.light};
  font-size: 0.9rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <h3>About Us</h3>
            <p>
              AmpleLark Technologies is a leading fintech company developing
              innovative solutions for the digital economy. Our apps are
              designed to make everyday tasks easier and more efficient.
            </p>
            <SocialIcons>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </a>
            </SocialIcons>
          </FooterSection>

          <FooterSection>
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#apps">Our Apps</a>
              </li>
              <li>
                <a href="#future">Future Developments</a>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>Our Apps</h3>
            <ul>
              <li>
                <a href="https://play.google.com/store/apps/details?id=com.easyrentsystems.app"
                  target="_blank"
                  rel="noopener noreferrer">EazyRent</a>
              </li>
              <li>
                <a href="https://play.google.com/store/apps/details?id=com.bookitapp.systems"
                  target="_blank"
                  rel="noopener noreferrer">BookIt</a>
              </li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>Contact Info</h3>
            <ul>
              <li>
                <LocationOnIcon /> 6056 Sibweni Road, Northmead, Lusaka
              </li>
              <li>
                <PhoneIcon /> +260 (211) 354-419
              </li>
              <li>
                <EmailIcon /> support@amplelark.com
              </li>
            </ul>
          </FooterSection>
        </FooterContent>

        <Copyright>
          <p>
            &copy; {new Date().getFullYear()} AmpleLark Technologies. All Rights
            Reserved.
          </p>
        </Copyright>
      </div>
    </FooterContainer>
  );
};

export default Footer;
